import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

export interface BlogPostEntry {
  fields: {
    title: string
    summary: string
  }
  sys: {
    id: string
    createdAt: string
    updatedAt: string
  }
  contentTypeId: 'teacherBlog'
}

export interface BlogPostEntries {
  items: Array<BlogPostEntry>
  limit: number
  skip: number
  total: number
  sys: {
    type: 'Array'
  }
}

export default class BlogRoute extends Route {
  @service contentfulClient!: ContentfulClientService
  model() {
    return this.contentfulClient.requestEntries<BlogPostEntry>({
      content_type: 'teacherBlog',
      order: '-sys.publishedAt',
      limit: 100,
      select: 'fields.title,fields.summary,sys.id,sys.createdAt,sys.updatedAt',
    })
  }
}
